<template lang="pug">
    //crud-form(
        ref='form'
            submit-text='crear vendedor'
        :fields='fields'
            @reset='resetForm'
            @submitForm='submitForm'
        )
    model-form(
        ref="form"
        reset-text="limpiar"
        submit-text="crear vendedor"
        :fields="fields"
        v-model="formData"
        @reset="resetForm"
        @submit="submitForm"
        )
</template>

<script>
//
import { mapActions } from 'vuex'
//
import { ModelForm } from '@/components/reusable_components/next'
// import { CrudForm } from '@/components/reusable_components'
//
import CommissionService from '@/services/api/commission'
import UserSellerService from '@/services/api/userSeller'
import BranchOfficeService from '@/services/api/branchOffice'
//
import UserFields from './partials/fields'
import MdlUserSeller from '../../models/General/GUserSeller'
//
export default {
    name: 'user-create',
    components: {
        'model-form': ModelForm,
    },
    data() {
        return {
            fields: UserFields,
            formData: {},
            // _templateFields: UserFields,
        }
    },
    methods: {
        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        async refresh() {
            this.$router.push({ name: 'users_list' })
        },

        /**
         *
         */
        resetForm: function() {
            this.formData = {}
        },

        /**
         *
         */
        async showSnackbar(type, title, message, callback = () => {}) {
            this.initSnackbar(this.fillSnack(type, title, message, false, 3000))
            callback()
        },

        /**
         *
         */
        submitForm: async function(data) {
            new MdlUserSeller({ ...data, is_ground_seller: false })
                .save()
                .then(this.handleResponse)
                .catch(this.showErrorSnackbar)
        },
        handleResponse(response) {
            //
            if (response.status === 'success')
                return this.showSuccessSnackbar(
                    this.$router.push({ path: '/users' })
                )
            //
            return this.showErrorSnackbar(response)
        },
        showErrorSnackbar(response) {
            this.initSnackbar(
                this.fillSnack('error', 'Error', response.error, false, 3000)
            )
        },
        showSuccessSnackbar() {
            this.initSnackbar(
                this.fillSnack(
                    'success',
                    'Éxito',
                    'Vendedor creado exitosamente.',
                    false,
                    3000
                )
            )
        },
    },
    beforeMount() {
        // this.fields = this.$data._templateFields
        this.setTitleTopBar('Crear vendedor')
        // this.resetForm()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_SELLER')) ctx.$router.push('/')
        })
    },
}
</script>
